import type { TextMeasurer } from '../render/measureCoverText';

let shared: CanvasRenderingContext2D | null = null;

/** A fake measure for a page with no canvas (a test): each character is half the font size wide. */
const fallback: TextMeasurer = {
  font: '',
  measureText(text: string) {
    const size = Number(/(\d+(?:\.\d+)?)px/.exec(this.font)?.[1] ?? 16);
    return { width: Array.from(text).length * size * 0.5 };
  },
};

/** One 2D context for measuring text outside a draw (the selection box of the stage). */
export function getMeasureContext(): TextMeasurer {
  if (shared !== null) {
    return shared;
  }
  if (typeof document === 'undefined') {
    return fallback;
  }
  shared = document.createElement('canvas').getContext('2d');
  return shared ?? fallback;
}
